import { __read, __spreadArray } from "tslib";
import { isString } from '@antv/util';
import { parseLength } from './dimension';
/**
 * format lineDash to [dash, dash]
 *
 * also support string format such as `"stroke-dasharray": "2px 4px"`
 */

export function parseLineDash(lineDash) {
  var formatted = [];

  if (isString(lineDash)) {
    lineDash.split(' ').forEach(function (segment) {
      var dimension = parseLength(segment);
      formatted.push(dimension.value);
    });
  } else {
    formatted.push.apply(formatted, __spreadArray([], __read(lineDash), false));
  }

  if (formatted && formatted.length === 1) {
    return [formatted[0], formatted[0]];
  }

  return [formatted[0], formatted[1]];
}